<template>
  <div class="mt-3 grid w-full grid-cols-2 gap-x-2">
    <div class="flex flex-col gap-x-2 gap-y-1">
      <h3 class="capitalize-first text-base font-bold text-gray-600">
        {{ $t('attributes.group_by') }}
      </h3>
      <div class="flex flex-row flex-wrap gap-2">
        <BaseButton
          v-for="item in groupByOptions"
          :key="item.id"
          :title="item.label"
          :icon="item.icon"
          size="small"
          :is-outline="item.id !== groupBy"
          inverse-icon-order
          @click="groupBy = item.id"
        />
      </div>
    </div>
    <div class="flex flex-col gap-x-2 gap-y-1">
      <h3 class="capitalize-first text-base font-bold text-gray-600">
        {{ $t('global.tri') + ' (' + $t('global.if_group_by_category') + ')' }}
      </h3>
      <div class="flex flex-row flex-wrap gap-2">
        <BaseButton
          v-for="item in sortElements"
          :key="item.value"
          :title="item.label"
          :icon="item.icon[1]"
          :icon-type="item.icon[0]"
          size="small"
          :is-outline="item.value !== direction"
          inverse-icon-order
          @click="direction = direction === item.value ? null : item.value"
        />
      </div>
    </div>
  </div>
  <div class="grid w-full grid-cols-2 gap-2">
    <div class="mt-4 flex flex-col gap-x-2 gap-y-1">
      <h3 class="capitalize-first text-base font-bold text-gray-600">
        {{ $t('global.column_status_to_display') }}
      </h3>
      <div class="flex flex-row flex-wrap gap-2">
        <BaseButton
          v-for="item in task_statuses"
          :key="item.id"
          :title="$t('enums.task.status.' + item.id)"
          :icon="item.icon"
          :color="item.bg_color"
          size="small"
          :is-outline="!visibleStatuses.includes(item.id)"
          inverse-icon-order
          @click="toggleVisibleStatus(item.id)"
        />
      </div>
      <p class="-mt-1 text-gray-500">
        {{ $t('global.column_status_to_display_info') }}
      </p>
    </div>
    <div class="mt-4 flex flex-col gap-x-2 gap-y-1">
      <h3 class="capitalize-first text-base font-bold text-gray-600">
        {{ $t('global.task_status_change') }}
      </h3>
      <div class="flex flex-row flex-wrap gap-2">
        <BaseButton
          v-for="item in statusInteractionOptions"
          :key="item.value"
          :title="item.label"
          :icon="item.icon"
          size="small"
          :is-outline="item.value !== statusInteraction"
          inverse-icon-order
          @click="statusInteraction = item.value"
        />
      </div>
    </div>
  </div>
  <div class="mt-6 flex justify-end">
    <BaseButton
      :title="$t('button.close')"
      size="small"
      @click="$emit('close-popover')"
    />
  </div>
</template>

<script>
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'DisplayOptionsTaskContent',
  components: { BaseButton },
  props: {
    sorting: {
      type: Object,
      required: true
    }
  },
  emits: ['update:sorting', 'close-popover'],
  data() {
    return {
      groupByOptions: [
        { id: 'status', label: this.$t('attributes.status') },
        { id: 'categories', label: this.$t('attributes.category') }
      ],
      sortElements: [
        {
          label: this.$t('global.asc'),
          icon: ['far', 'arrow-up-a-z'],
          value: 'asc'
        },
        {
          label: this.$t('global.desc'),
          icon: ['far', 'arrow-down-z-a'],
          value: 'desc'
        }
      ],
      statusInteractionOptions: [
        {
          value: 'cycle',
          label: this.$t('global.in_one_click'),
          icon: 'arrow-pointer'
        },
        {
          value: 'select',
          label: this.$t('global.select'),
          icon: 'list'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      task_statuses: 'metadata/getMetadataTaskStatuses'
    }),
    groupBy: {
      get() {
        return this.sorting.group
      },
      set(value) {
        this.$emit('update:sorting', { ...this.sorting, group: value })
      }
    },
    direction: {
      get() {
        return this.sorting.direction
      },
      set(value) {
        this.$emit('update:sorting', { ...this.sorting, direction: value })
      }
    },
    visibleStatuses() {
      return this.sorting.visibleStatuses ?? []
    },
    statusInteraction: {
      get() {
        return this.sorting.statusInteraction ?? 'cycle'
      },
      set(value) {
        this.$emit('update:sorting', {
          ...this.sorting,
          statusInteraction: value
        })
      }
    }
  },
  methods: {
    toggleVisibleStatus(statusId) {
      const current = [...(this.sorting.visibleStatuses ?? [])]
      const idx = current.indexOf(statusId)
      if (idx === -1) {
        current.push(statusId)
      } else {
        current.splice(idx, 1)
      }
      this.$emit('update:sorting', {
        ...this.sorting,
        visibleStatuses: current
      })
    }
  }
}
</script>
